export const UNIDADES= [
  {'value':'Metro'},
  {'value':'Kilómetro'},
  {'value':'Metro²'},
  {'value':'Área'},
  {'value':'Hectárea'},
  {'value':'Litro'},
  {'value':'Hectolitro'},
  {'value':'Hora'},
  {'value':'Dia'},
  {'value':'Kilogramo'},
  {'value':'Tonelada'},
]
